// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"03740803","302":"d3cd4e36","841":"c52faf2b"}[chunkId] + ".chunk.js";
};